import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {connect} from 'react-redux';

import ClientTimestamp from 'app/components/common/client-timestamp';
import Link            from 'app/components/common/link';
import CommentsPopover from 'app/components/company-admin/grant-system/comments-popover';
import FormSubmission  from 'app/components/forms/submission';
import format          from 'app/helpers/format';
import paths           from 'app/paths';
import EntitiesSlx     from 'app/selectors/entities';
import CadminSlx       from 'app/selectors/company-admin/';




class AppProfile extends React.PureComponent {

  constructor(props) {
    super(props);

    this.renderComments = this.renderComments.bind(this);
  }

  get forms() {
    const {formMap, program} = this.props;
    const ids = program?.formIds || [];
    return ids.map(id => formMap[id]).filter(f => f);
  }

  get submissions() {
    return this.props.app?.formSubmissions || [];
  }

  get pairs() {
    const forms = [...this.forms];
    const submissions = [...this.submissions];

    const pairs = [];
    forms.forEach((form) => {
      const subIndex = submissions.findIndex(sub => sub.formId === form.id);
      if (subIndex < 0) return pairs.push([form, null]);
      const sub = submissions[subIndex];
      pairs.push([form, sub]);
      submissions.splice(subIndex, 1);
    });
    submissions.forEach((sub) => {
      pairs.push([null, sub]);
    });
    return pairs;
  }

  get workflow() {
    const {app, wfMap} = this.props;
    if (!wfMap || !app) return null;
    return wfMap[app.grantWorkflowId] || null;
  }
  get stage() {
    const {app} = this.props;
    if (!app) return null;
    return (this.workflow?.stages || []).find(stage => stage.id === app.currentGrantStageId) || null;
  }

  renderComments(answer) {
    const {app, assId} = this.props;
    if (!app) return null;
    return <CommentsPopover answer={answer} appId={app.id} assId={assId} />;
  }

  renderMeta() {
    const {app, program} = this.props;
    const {company} = program;
    const {user, nonprofit} = app;

    return (
      <div className="gapp-pro-meta">
        <table className="attrs gapp-pro-meta-attrs">
          <tbody>
            <tr>
              <th>Submitted</th>
              <td><ClientTimestamp timestamp={app.submittedTs} format="MMM D, YYYY, h:mma" showTz /></td>
            </tr>
            <tr>
              <th>Applicant</th>
              <td>
                {!!user && (<>
                  <span>{`${user.firstName} ${user.lastName}`}</span><br />
                  <span>{user.email}</span>
                </>)}
              </td>
            </tr>
            <tr>
              <th>Nonprofit</th>
              <td>
                {!!nonprofit && (<>
                  <Link href={paths.nonprofit(nonprofit)} className="pink-hover">{`${nonprofit.name}`}</Link><br />
                  <span>{nonprofit.ein || nonprofit.registeredNumber}</span>
                </>)}
              </td>
            </tr>
            <tr>
              <th>Amount Requested</th>
              <td>{_.isFinite(app.amountRequested) && format.usd(app.amountRequested)}</td>
            </tr>
            <tr>
              <th>Amount Awarded</th>
              <td>{_.isFinite(app.amountAwarded) && format.usd(app.amountAwarded)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const {app, program, center, className, company} = this.props;
    if (!app || !program) return null;

    const programPath = paths.cadminGrantProgram(company.slug, program.id);
    const appPath = paths.cadminGrantApp(company.slug, app.id);

    return (
      <div className={`gapp-pro ${className} ${center ? 'center' : 'no-center'}`}>
        <div className="gapp-pro-head">
          <Link href={programPath} className="pink-hover">{program.title}</Link>
          <h1 className="gapp-pro-title">
            <Link href={appPath} className="gapp-pro-title-link">Grant Application #{app.number}</Link>
            {!!this.stage && <span className="gapp-pro-title-chip" style={{backgroundColor: this.stage.color}}>{this.stage.title}</span>}
          </h1>
        </div>
        {this.renderMeta()}

        {this.pairs.map(([form, submission]) => {
          return (
            <FormSubmission key={form?.id || submission?.id} form={form} submission={submission} nested className="gapp-pro-fsub" renderComments={this.renderComments} />
          );
        })}

      </div>
    );
  }

}

AppProfile.propTypes = {
  app: PropTypes.object,
  program: PropTypes.object,
  center: PropTypes.bool,
  className: PropTypes.string,
  assId: PropTypes.string,
};

AppProfile.defaultProps = {
  app: null,
  program: null,
  center: true,
  className: '',
  assId: null,
};

const stateToProps = (state) => ({
  formMap: EntitiesSlx.forms(state),
  wfMap: EntitiesSlx.grantWorkflows(state),
  company: CadminSlx.company(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(AppProfile);
